import React from "react";
export function Disclaimer() {
  return <footer className="bg-[#061226] px-4 pb-28 pt-12 sm:px-6 sm:pb-32" data-id="element-135" data-mp="223ikeqta8qd6">
      <div className="mx-auto max-w-3xl text-sm leading-relaxed text-white/65" data-id="element-136" data-mp="pbfvrphfw1p0">
        <h2 className="font-display text-base font-bold uppercase tracking-wide text-white" data-id="element-137" data-mp="13zkdor8o496q">Important Educational Disclaimer</h2>
        <div className="mt-4 space-y-3" data-id="element-138" data-mp="z6zmlxh5ca6w">
          <p data-id="element-139" data-mp="1czz1bx93u0de">
            Musculoskeletal Clinical Pathway™ is an educational resource intended to support professional learning and the
            organization of musculoskeletal assessment concepts.
          </p>
          <p data-id="element-140" data-mp="1myokrugnfsvr">
            It does not provide a guarantee of diagnostic accuracy or clinical outcomes. It does not replace professional
            education, supervised clinical training, individualized patient assessment, professional judgment, local clinical
            guidelines, emergency procedures, or appropriate medical referral.
          </p>
          <p data-id="element-141" data-mp="3js9k4mp1ug55">
            Clinical decisions must be made by appropriately qualified professionals within their scope of practice and in
            accordance with applicable laws, regulations, and professional standards.
          </p>
          <p data-id="element-142" data-mp="1ij39ln49alcb">
            The educational cases are illustrative and should not be interpreted as individualized medical advice or definitive
            diagnostic protocols.
          </p>
        </div>
        <div className="mt-8 border-t border-white/10 pt-6 text-center" data-id="element-143" data-mp="1s8wj8iku8qdx">
          <p data-id="element-144" data-mp="1sb0mqzetrndo">© 2026 Musculoskeletal Clinical Pathway™. All rights reserved.</p>
          <p className="mt-1" data-id="element-145" data-mp="1x5whi7bg4ouh">Created by Dr. Ryan Carter.</p>
        </div>
      </div>
    </footer>;
}